import React, { useState } from "react";
import logo from "../assets/logo-bg.png";
import { Clock, Mail, Bug, PieChart } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <div className="p-8">
        <div className="flex justify-center mb-2">
          <img
            src={logo}
            alt="Tradie Time Logo"
            className="h-[190px] w-auto object-contain"
          />
        </div>

        <div className="space-y-6 text-gray-700">
          <div className="bg-gray-50 rounded-lg p-6 border-l-4  border-blue-900">
            <h3 className="text-xl font-bold text-blue-900 mb-3">
              What is Tradie Time?
            </h3>
            <p className="leading-relaxed">
              Tradie Time is a comprehensive time tracking application
              specifically designed for small tradesperson companies including
              builders, plumbers, electricians, and other skilled trades. Our
              platform simplifies workforce management and provides real-time
              insights into team productivity.
            </p>
          </div>

          <div className="bg-blue-900 text-white rounded-lg p-6">
            <h3 className="text-xl font-bold mb-3 text-yellow-500">
              Our Mission
            </h3>
            <p className="leading-relaxed">
              At Tradie Time, we believe that time tracking should be simple,
              not complicated. Our mission is to provide tradesperson companies
              with an intuitive tool that helps them focus on what they do best
              while we handle the details of time management and reporting.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-yellow-50 rounded-lg p-6 border-l-4 border-yellow-500">
              <h3 className="text-lg font-bold text-blue-900 mb-3 flex items-center gap-2">
                <Clock className="w-5 h-5 text-yellow-500" />
                For Tradesmen
              </h3>
              <ul className="space-y-2 text-sm">
                <li className="flex items-start gap-2">
                  <span className="text-yellow-500 font-bold">•</span>
                  <span>Easy time entry with start and end times</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-yellow-500 font-bold">•</span>
                  <span>
                    Categorize work by type (plumbing, electrical, etc.)
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-yellow-500 font-bold">•</span>
                  <span>Track materials and shopping lists</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-yellow-500 font-bold">•</span>
                  <span>Edit and manage entries with ease</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-yellow-500 font-bold">•</span>
                  <span>Mobile-friendly interface for on-site access</span>
                </li>
              </ul>
            </div>

            <div className="bg-blue-50 rounded-lg p-6 border-l-4 border-blue-900">
              <h3 className="text-lg font-bold text-blue-900 mb-3 flex items-center gap-2">
                <PieChart className="w-5 h-5 text-blue-900" />
                For Managers
              </h3>
              <ul className="space-y-2 text-sm">
                <li className="flex items-start gap-2">
                  <span className="text-blue-900 font-bold">•</span>
                  <span>Overview of all team members' work hours</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-900 font-bold">•</span>
                  <span>Visual analytics and work breakdown charts</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-900 font-bold">•</span>
                  <span>Search and filter by date range</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-900 font-bold">•</span>
                  <span>Track productivity by category</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-900 font-bold">•</span>
                  <span>Access to team material lists</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center border-t-2 border-gray-200 pt-6">
            <p className="text-gray-600 mb-4">Need help or have questions?</p>
            <div className="flex justify-center gap-4">
              <button className="bg-yellow-500 text-white px-6 py-3 rounded-lg hover:bg-yellow-600 transition-colors font-semibold flex items-center gap-2">
                <a
                  href="mailto:admin@tradietime.co.nz"
                  className="flex items-center gap-2 hover:text-yellow-500 transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  <span>Contact Support</span>
                </a>
              </button>
              <button className="bg-blue-900 text-white px-6 py-3 rounded-lg hover:bg-blue-800 transition-colors font-semibold flex items-center gap-2">
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdgh9wDY6KG5peKcRKVI0cYmxeNXY4fc-IxyHhg-dthA5A8nA/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 hover:text-yellow-500 transition-colors"
                >
                  <Bug className="w-5 h-5" />
                  <span>Report a Bug</span>
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
